import React from 'react'

const OemHero = () => {
  return (
    <section id="c-heroOem" className="c-sectionHero">
    <div className="container">
        <div className="row">
            <div className="col-lg-5 col-md-6 col-sm-12 c-heroContentCol">
                <div className="c-heroContent">
                    <h5 className="c-heading46Bold">We help you grow by keeping the money flow </h5>
                    <p className="c-para22Regular">QR-based FI-MEN technology enables end-to-end contactless lending.</p>
                    <a href="#c-sectionRequestInfoForm" className="c-btnOrangeSolidSharp">Get in Touch &nbsp;&nbsp; <b>></b></a>
                </div>
            </div>
            <div className="col-lg-7 col-md-6 col-sm-12 c-heroImgCol">
                <img src="./images/oem/hero_oem_main.png" className="img-fluid" alt=""  />
            </div>
        </div>
    </div>
</section>
  )
}

export default OemHero